import React from 'react'
import Form from './form'

export default function ChallengeAdd (props) {
  const data = { active: true }
  return (
    <Form data={data} {...props} />
  )
}
